import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 24px;
  border-radius: ${({ theme }) => theme.zds.border.radius100};
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  flex-direction: column;
  overflow: hidden;
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
`

export const Year = styled.span`
  font-weight: 500;
  color: ${props => props.theme.colors.color545e6c};
  font-size: 16px;
  font-family: 'Inter';
  margin-right: 7px;
`

export const YearContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 16px;
`
export const TableContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: scroll;

  padding-bottom: 50px;
`
